import { Router } from "./../../router";
import {autoinject, Container} from "aurelia-dependency-injection";
import {UserDetailsView} from "./user-details";
import {Navigation} from "../../navigation/navigation";
import Marionette from "../../shared/marionette-mustache";
import {FullScreenThinker} from "../plugins/full-screen-thinker";
import {ErrorMessage} from "../../shared/views/error-message";
import * as BootstrapDialog from "bootstrap3-dialog";
import * as Mousetrap from "mousetrap";
import "mousetrap-global-bind";
import { AuthService } from "../../authentication/auth-service";
import { AppUser } from "../../authentication/app-user";

const template = require<string>("../../shared/views/master-view.html");
require("../../../assets/css/bootstrap.less");
require("../../../assets/css/glyphicons.less");
require("../../processing/styles/processing.less");
require("../styles/layout.less");

const options = {
    template: template
};
const dom = {
    MOBILE_DOCUMENT_LIST: "#mobile-document-list"
};

@autoinject
export class MasterView extends Marionette.LayoutView<any> {

    public navRegion: Marionette.Region;
    public dialogRegion: Marionette.Region;
    public thinkerRegion: Marionette.Region;
    public userDetailsRegion: Marionette.Region;
    private user: AppUser;

    constructor(private userDetails: UserDetailsView,
                private navView: Navigation,
                private thinker: FullScreenThinker,
                private errorMessage: ErrorMessage,
                private authService: AuthService) {
        super(options);
        this.user = authService.AppUser;
        this.setupModelListeners();
        $(document).on("click", (event) => {
            if ($(event.target).parents(".popover").length || $(event.target).hasClass("editable-click")) {
             return;
            }
            $(".paragraph-controls").popover("destroy");
            $(".popover").popover("hide");

            if (!$(event.target).parents(".close-on-any-click").length) {
                 $(".close-on-any-click").removeClass("open");
            }
        });
    }

    public regions(): any {
        const regions: any = {
            navRegion: "#nav-region",
            dialogRegion: "#dialogs",
            userDetailsRegion: "#user-details-region",
            thinkerRegion: "#thinker-region",
        };
        return regions;
    }

    public onRender() {
        $("#loading").hide();
        this.$("#application-container").show();
        this.setupIEBugFix();
        this.setupAccessibility();
    }

    public onBeforeShow() {
        this.navRegion.show(this.navView);
        this.userDetailsRegion.show(this.userDetails);
        this.updateUserInterface();
    }

    public clearDialogs() {
        this.dialogRegion.empty({ preventDestroy: true });
    }

    public setThinkerMessage(message: string) {
        this.thinker.model.set("Message", message);
    }

    public showThinker(message: string) {
        this.thinkerRegion.show(this.thinker);
        this.thinker.model.set("Message", message);
    }

    public hideThinker() {
        this.thinkerRegion.empty({preventDestroy: true});
    }

    /** Conduit to the navView - think having this method is more elegant than exposing the whole view publicly */
    public mobileHideDocumentList() {
        this.navView.mobileHideDocumentList();
    }

    private setupAccessibility() {
        this.setupBindings({
            "shift+alt+/": () => this.showShortcuts(),
            "alt+0": () => this.showShortcuts(),
            "shift+alt+s": () => this.goto("#search-button a"),
            "shift+alt+a": () => this.goto("#advanced-search-button a"),
            "shift+alt+b": () => this.goto("#browse-button a"),
            "shift+alt+d": () => this.goto("#desktop-button a"),
            "shift+alt+m": () => this.goto("#my-justis-button a"),
            "shift+alt+,": () => this.goto(".js-results-pager[data-page='left']"),
            "shift+alt+.": () => this.goto("#next-page-button"),
            "shift+alt+c": () => this.gotoContent()
        });

        this.$el.find("#goto-content").click(() => { this.gotoContent(); });
        this.$el.find("#show-shortcuts").click(() => { this.showShortcuts(); });
    }

    private goto(what: string) {
        this.$(what).trigger("click");
    }

    private setupBindings(bindings) {
        const keys = Object.keys(bindings);
        for (const key of keys) {
            try {
                Mousetrap.bindGlobal(key, bindings[key]);
            } catch (e) {
               // console.log(e);
            }
        }
    }

    private gotoContent() {

        let elementToFocus = this.$el.find("#viewport-content #search-region .document-link:visible").first(); // Find the first result if there are any

        if (elementToFocus.length === 0) {
            elementToFocus = this.$el.find("#desktop-region .nav.fulltext-nav li a:visible").first();
        }

        if (elementToFocus.length === 0) {
            elementToFocus = this.$el.find("#my-justis-region .navbar .nav li a:visible").first();
        }

        if (elementToFocus.length === 0) {
            elementToFocus = this.$el.find("#viewport-content a:visible").first();
        }

        elementToFocus.focus();
    }

    private showShortcuts() {
        this.$("#shortcuts-dialog").attr("aria-hidden", "false").modal("show");
    }

    private setupModelListeners(): void {
        this.user.on("refresh", () => {
            this.updateUserInterface();
        });
    }

    private updateUserInterface() {
        // tslint:disable-next-line:triple-equals // Using non-strict equality because IE was thinking UserId was a string
        $("body").toggleClass("internal-user", this.user.UserId == 809);
        $("body").toggleClass("super-user", this.user.IsSuperUser);
        $("body").toggleClass("production-user", this.user.IsProductionUser);
        $("body").toggleClass("allow-admin", this.user.AllowAdmin);
        this.updateSignInState();
        this.updateSignInType();
        this.updateSignInName();
        this.updateSignInOrganisation();
        this.updateFeatureFlags();
    }

    private updateFeatureFlags(): void {
        // Reset the feature flag classes before updating
        $("body").removeClass((index, className) => {
            return (className.match (/(^|\s)feature-flag-\S+/g) || []).join(" ");
        });
        this.user.FeatureFlags.forEach((flag) => {
            $("body").addClass("feature-flag-" + flag.toLowerCase());
        });
    }

    private updateSignInState(): void {
        if (this.user.IsAuthenticated) {
            $("body").addClass("authenticated");
            $("body").removeClass("ip-authenticated");
        } else {
            $("body").removeClass("authenticated");
            switch (this.user.get("authenticationType")) {
                case "athens":
                    // document.location.href = this.user.AthensSignoutUrl;
                    break;
                case "shibboleth":
                    break;
                default:
                    break;
            }
        }
    }

    private updateSignInType(): void {
        $("body").toggleClass("ip-authenticated", this.user.AuthenticatedByIp);
        this.$("#user-details-ip").toggle(this.user.AuthenticatedByIp);
        this.$("#user-details-ip-mobile").toggle(this.user.AuthenticatedByIp);
    }

    private updateSignInName(): void {
        let name = this.user.Email;
        const authType = this.user.AuthenticationType;
        if (authType === "Athens") {
            name = this.user.OrganisationName;
        }
        this.$(".email-address").text(name);
    }

    private fetchPersonalLogoAndInjectToHtml(): void {
        const viewport = "#viewport";
        const bodyLogo = ".personalised-logo-body";
        const userInfoContainer = "#user-info-container";
        const headLogo = ".personalised-logo-head";

        $(bodyLogo).remove();
        $(headLogo).remove();

        if ($(userInfoContainer).children(headLogo).length === 0) {
            $(userInfoContainer).append(`<div class="personalised-logo-head" style="background-image: url('${this.user.CustomHeader}')"></div>`);
        }

        if ($(viewport).children(bodyLogo).length === 0) {
            $(viewport).prepend(`<div class="personalised-logo-body" style="background-image: url('${this.user.CustomFooter}')"></div>`);
        }
    }

    private updateSignInOrganisation(): void {
        this.$("#organisation-name").text(this.user.OrganisationName);
        this.$("#organisation-name-mobile").text(this.user.OrganisationName);
        this.fetchPersonalLogoAndInjectToHtml();
        $("body").removeClass((index, css) => {
            return (css.match(/(^|\s)sku-\S+/g) || []).join(" ");
        }).addClass("sku-" + this.user.Sku.toLowerCase());
    }

    private setupIEBugFix() {
        window.onfocus = () => {
            const ua = window.navigator.userAgent;
            const msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                forceRedraw(document.getElementById("application-container"));
            }
        };

        const forceRedraw = (element) => {
            element.style.display = "none";
            // tslint:disable-next-line:no-unused-expression
            element.offsetHeight;
            element.style.display = "block";
        };
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/views/master-view.ts